import { pushPromoView, pushPromotionClick, pushImpressions } from '@v4/common/utils/data-layer';
import { navigateTo } from '@v4/http/request';

export default {
    onLeadFormMounted(...args) {
        this.$emit('lead-form-mounted', ...args);
    },
    onLeadFormError({ message }) {
        this.notifyError(message, { position: 'top-center' });
    },
    mediaGalleryShown(source, { photoSwipe }) {
        if (photoSwipe && typeof photoSwipe.goTo === 'function') {
            const index =
                this.fetchedData.media &&
                this.fetchedData.media.gallery.length &&
                this.fetchedData.media.gallery.findIndex((media) => media[source]);

            index && photoSwipe.goTo(index);
        }
    },
    onProductViewerEvent(eventName, data) {
        const args = ['product-viewer-360', eventName];

        if (data) {
            args.push(data);
        }

        this.pushGaEvent(...args);
    },
    onMediaSwipeInit() {
        this.$el.classList.add('multi-section--gallery-visible');
    },
    onMediaSwipeClose() {
        this.$el.classList.remove('multi-section--gallery-visible');
    },
    openCompareModal() {
        this.pushGaEvent(
            `Multi section page (${this.fetchedData.id})`,
            'vehicle compare click',
            `Multi section page (${this.fetchedData.id}) button - Compare button click`
        );

        this.openCompareVehicleModalAndHandleClick(
            null,
            this.fetchedData,
            [],
            `${this.$t('compare.compare')} ${this.fetchedData.makeName} ${this.fetchedData.submodelCommercialName}`,
            this.$t('compare.compare')
        );
    },
    setFormMetaData(data, options = { loading: true }) {
        // fake loading time
        if (options.loading) {
            this.form.busy = true;

            setTimeout(() => {
                this.form.busy = false;
            }, 1000);
        }

        this.form.title = (data && data.title) || '';
        this.form.subtitle = (data && data.subtitle) || '';
    },
    setSidebarMetaData(data) {
        this.sidebar.title = (data && data.title) || '';
        this.sidebar.subtitle = (data && data.subtitle) || '';
    },
    showForm(bool) {
        const ctaTogglerElm = document.getElementById('multi-section-cta-toggler');

        if (!ctaTogglerElm) {
            return;
        }

        ctaTogglerElm.checked = bool;
    },
    handleSuggestionCardClick(event, url, { id, name, position }) {
        event.preventDefault();

        this.pushGaEvent(`${this.pageAbbr.toUpperCase()} suggestion cards`, 'click', name, position);

        // In order to navigate away if tag manager is not loaded because of adblockers
        const timeoutId = setTimeout(() => navigateTo(url), 1000);

        pushPromotionClick(
            {
                id: `${this.pageAbbr}-crs-${id}`,
                name,
                position: `${this.pageAbbr}-crs_${position}`,
            },
            () => {
                clearTimeout(timeoutId);
                navigateTo(url);
            }
        );
    },
    onCardCompareClick(comparison = {}) {
        this.pushProductClickToDataLayer(comparison.items || [], { list: this.pageAbbr });
    },
    onComparedCarsReady(analytics = {}) {
        if (!analytics) {
            return;
        }

        pushImpressions(analytics.impressions);
    },
    onSimilarCarsSliderReady(items = [], analytics = {}) {
        if (analytics) {
            pushImpressions(analytics.impressions);
        }

        pushPromoView(
            items.map(({ id, name, position }) => ({
                id: `${this.pageAbbr}-crs-${id}`,
                name,
                position: `${this.pageAbbr}-crs_${position}`,
            }))
        );
    },
    onPromotionShowMoreClick() {
        this.pushGaEvent('offer', 'click', 'show-more');
        this.pushGaEvent('vehicle detail page', 'interaction with "offerte in corso"', 'show-more');
    },
    onPromotionSlideChange() {
        this.pushGaEvent('vehicle detail page', 'interaction with "offerte in corso"', 'slider change');
    },
    onPromotionsResponse(...args) {
        const requestData = args[0];
        if (
            requestData &&
            requestData.response &&
            requestData.response.data &&
            requestData.response.data.items &&
            requestData.response.data.items.length
        ) {
            this.hasPromotions = true;
        } else {
            this.hasPromotions = false;
        }
    },
    onPromotionsError() {
        this.hasPromotions = false;
    },
    onSuggestedCarsResponse(...args) {
        const { response } = args[0];
        this.hasSuggestions = !!(response && response.items && response.items.length);
    },
    onSuggestedCarsError() {
        this.hasSuggestions = false;
    },
    onComparisonCarsResponse(...args) {
        const { response } = args[0];
        this.hasComparisons = !!(response && response.items && response.items.length);
    },
    onComparisonCarsError() {
        this.hasComparisons = false;
    },
};
